import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: () => {
        const saved = localStorage.getItem('lang')
        return saved === 'CN' ? '/cn/home' : '/en/home'
      }
    },
    {
      path: '/:lang(en|cn)',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '',
          redirect: 'home'
        },
        {
          path: 'home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'gsxg.gongsi',
            keywords: 'seo.home.keywords',
            description: 'seo.home.description'
          }
        },
        {
          path: 'AboutKangLin',
          name: 'AboutKangLin',
          component: resolve => require(['@/view/AboutKangLin/index'], resolve),
          meta: {
            title: 'gsxg.gonsgi1',
            keywords: 'seo.about.keywords',
            description: 'seo.about.description'
          }
        },
        {
          path: 'Production',
          name: 'Production',
          component: resolve => require(['@/view/Production/index'], resolve),
          meta: {
            title: 'gsxg.gonsgia',
            keywords: 'seo.production.keywords',
            description: 'seo.production.description'
          }
        },
        {
          path: 'service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: 'gsxg.gonsgij'
          }
        },
        {
          path: 'newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: 'gsxg.gonsgib'
          }
        },
        {
          path: 'companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: 'gsxg.gonsgik'
          }
        },
        {
          path: 'enterprise',
          name: 'enterprise',
          component: resolve => require(['@/view/Enterprise/index'], resolve),
          meta: {
            title: 'gsxg.gonsgic',
            keywords: 'seo.enterprise.keywords',
            description: 'seo.enterprise.description'
          }
        },
        {
          path: 'join',
          name: 'join',
          component: resolve => require(['@/view/Join/index'], resolve),
          meta: {
            title: 'gsxg.gonsgid',
            keywords: 'seo.join.keywords',
            description: 'seo.join.description'
          }
        },
        {
          path: 'prefecture',
          name: 'prefecture',
          component: resolve => require(['@/view/Prefecture/index'], resolve),
          meta: {
            title: 'gsxg.gonsgie',
            keywords: 'seo.prefecture.keywords',
            description: 'seo.prefecture.description'
          }
        },
        {
          path: 'news',
          name: 'news',
          component: resolve => require(['@/view/News/index'], resolve),
          meta: {
            title: 'gsxg.gonsgif',
            keywords: 'seo.news.keywords',
            description: 'seo.news.description'
          }
        },
        {
          path: 'newsdetail',
          name: 'newsdetail',
          component: resolve => require(['@/view/NewsDetail/index'], resolve),
          meta: {
            title: 'gsxg.gonsgig',
            keywords: 'seo.news.keywords',
            description: 'seo.news.description'
          }
        },
        {
          path: 'teamwork',
          name: 'teamwork',
          component: resolve => require(['@/view/Teamwork/index'], resolve),
          meta: {
            title: 'gsxg.gonsgih',
            keywords: 'seo.teamwork.keywords',
            description: 'seo.teamwork.description'
          }
        },
        {
          path: 'contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: 'gsxg.gonsgii',
            keywords: 'seo.contact.keywords',
            description: 'seo.contact.description'
          }
      },
      {
        path: 'search',
        name: 'search',
        component: resolve => require(['@/view/Search/index'], resolve),
        meta: {
          title: 'gsxg.gonsgig'
        }
      },
        {
          path: 'servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: 'gsxg.gonsgij'
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/en/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js